import { apiClient } from './client';

export interface ReportScope {
  county?: string;
  district?: string;
  division?: string;
  location?: string;
  period?: string;
}

export interface ReportResult {
  type: string;
  rows: any[];
  total_rows: number;
  generated_at: string;
  period: string;
}

export const reportsApi = {
  async getReports(type: string, scope: ReportScope = {}): Promise<ReportResult> {
    const params = new URLSearchParams({ type });
    if (scope.county) params.append('county', scope.county);
    if (scope.district) params.append('district', scope.district);
    if (scope.division) params.append('division', scope.division);
    if (scope.location) params.append('location', scope.location);
    if (scope.period) params.append('period', scope.period);
    return apiClient.get(`/reports/?${params.toString()}`);
  },
};
